/**
 * @voltxampere/schema — Migration registry
 *
 * Per SPECS §1.8 and BLUEPRINT §31 Sprint 2 DoD ("migration framework
 * stubbed (empty migration array)"), the registry ships empty. Real
 * migrations land as schema versions evolve past 0.1.0.
 *
 * Tests construct ad-hoc migrations with the `Migration` interface and
 * the `migrateWithMigrations` helper in `./migrate.ts`, which accepts an
 * explicit list — this keeps the production registry clean while fully
 * exercising the chaining algorithm.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { migration_0_1_0_to_0_2_0 } from "./0.1.0-to-0.2.0.js";
import { migration_0_2_0_to_0_3_0 } from "./0.2.0-to-0.3.0.js";
import { migration_0_3_0_to_0_4_0 } from "./0.3.0-to-0.4.0.js";
export const MIGRATIONS = [
    migration_0_1_0_to_0_2_0,
    migration_0_2_0_to_0_3_0,
    migration_0_3_0_to_0_4_0,
];
//# sourceMappingURL=registry.js.map